import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataSortMenuTranslations() {
  return {
    name: {
      text: $localize`:@@scandataSortMenu.name:Name`,
      desc: 'Displayed as an option in a context menu to sort a list of datasets by Name.  ',
    },
    uploadedDate: {
      text: $localize`:@@scandataSortMenu.uploadedDate:Upload Date`,
      desc: 'Displayed as an option in a context menu to sort a list of datasets by Upload Date.  ',
    },
    captureDate: {
      text: $localize`:@@scandataSortMenu.captureDate:Capture Date`,
      desc: 'Displayed as an option in a context menu to sort a list of datasets by Capture Date.  ',
    },
  } satisfies TranslationMap;
}
